import jsCookie from 'js-cookie'

import {
  choicesVersionCookieName,
  currencyCookieName,
  localeCookieName,
  originCookieName,
  visitorCookieValidityInDays,
} from '../constants/http'

// The cookies that record a choice the visitor made. The country is a fact, not a choice: it is
// detected again when its cookie lapses, so it is not renewed.
const choiceCookieNames = [localeCookieName, currencyCookieName, originCookieName]

// Bump it to drop every stored choice once, whenever what a choice cookie means changes
const CHOICES_VERSION = '1'

// Outlives every choice it vouches for, which are renewed on the same page loads
const CHOICES_VERSION_VALIDITY_IN_DAYS = 365

// A language the visitor picked, or their profile's - the preference the middleware follows on `/`
// and the portal (docs/visitor-preferences.md)
export const saveLanguageChoice = (locale: string) => {
  jsCookie.set(localeCookieName, locale, {expires: visitorCookieValidityInDays})
}

/**
 * Renews the visitor's choices on every page load, so they lapse only after six months without a
 * visit rather than six months after they were made - see docs/visitor-preferences.md.
 *
 * Choice cookies written before those rules mix real choices with guesses - a fallback region, a
 * language next-intl stored just because a page was opened - and cannot be told apart, so they are
 * dropped once rather than renewed into six-month choices.
 */
export const renewChoices = () => {
  const isCurrent = jsCookie.get(choicesVersionCookieName) === CHOICES_VERSION

  for (const name of choiceCookieNames) {
    const value = jsCookie.get(name)
    if (value === undefined) {
      continue
    }
    if (isCurrent) {
      jsCookie.set(name, value, {expires: visitorCookieValidityInDays})
    } else {
      jsCookie.remove(name)
    }
  }

  jsCookie.set(choicesVersionCookieName, CHOICES_VERSION, {
    expires: CHOICES_VERSION_VALIDITY_IN_DAYS,
  })
}
